import { coreBase } from '../../../configs/coreBase';

export const buscarCarrinho = () => {
  return async dispatch => {
    var itens = [];
    var checkout = [];
    if(localStorage.checkout != undefined && localStorage.checkout != [])
      checkout = JSON.parse(localStorage.checkout);

    var carrinhoAtual = checkout.map(i => i.id).join(',');

    var r = await coreBase.get(`/catalogo/carrinho/${carrinhoAtual}`);
    
    if(r) itens = r.data;
    
    var finalItens = [];

    //PREENCHA A QTD E UNIDADE CERTA SALVA SESSÃO ANTERIOR 
    itens.map((item, i) => {
      checkout.map(c => {
        if(item.CodProduto == c.id && item.Unidade == c.unid) {
          itens[i].Quantidade = c.qtd;
          finalItens.push(itens[i]);
        }
      });
    });

    dispatch({
      type: "SET_ITENS",
      payload: finalItens
    });
  }
}

export const setItens = (item) => {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    var itens = checkout.itens;
    itens.push(item);

    dispatch({
      type: "SET_ITENS",
      payload: itens
    });
  }
}

export const removeItem = (index) => {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    var itens = checkout.itens;
    itens.splice(index, 1);

    dispatch({
      type: "SET_ITENS",
      payload: itens
    });
  }
}

export const updateItem = (qtd, index) => {
  return async (dispatch, getState) => {
    const { checkout } = getState();
    var itens = checkout.itens;
    itens[index].Quantidade = qtd;

    dispatch({
      type: "SET_ITENS",
      payload: itens
    });
  }
}